import SteelCompass from '../services/SteelCompass';
import {
  GET_CLIENTS,
  CREATE_CLIENT,
  UPDATE_CLIENT_STATUS
} from '../constants/ClientsActionTypes';

export function getClients(filters = []) {
  const params = {};

  filters.forEach(filter => {
    if (filter.mode === 'clientId') {
      params.clientId = filter.value;
    }
    if (filter.mode === 'email') {
      params.email = filter.value;
    }
    if (filter.mode === 'status') {
      params.status = filter.value;
    }
  });

  return {
    type: GET_CLIENTS,
    promise: SteelCompass.request('mr.wolf-user', 'getInvoicingClients', params)
  };
}

export function addClient({ id }) {
  return {
    type: CREATE_CLIENT,
    promise: SteelCompass.request('mr.wolf-user', 'addInvoicingClient', { userId: id })
  };
}

export function updateClientStatus(userId, status) {
  return {
    type: UPDATE_CLIENT_STATUS,
    promise: SteelCompass.request('mr.wolf-user', 'updateInvoicingClientStatus', { userId, status })
  };
}
